/**
 * AI brand colors - intentionally different from main theme for visual distinction.
 * Used by Enable AI components (AIAssistant, AIAssistantButton).
 * Centralized here so changes apply everywhere.
 */
export const AI_COLORS = {
    // Primary purple shades
    primary: '#8b5cf6',
    primaryDark: '#7c3aed',
    primaryDarker: '#6d28d9',

    // Gradients
    gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 50%, #6d28d9 100%)',
    gradientHover: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 50%, #7c3aed 100%)',

    // Backgrounds
    bgLight: '#f8f7ff',
    bgLighter: '#fafafa',
    bgSubtle: 'rgba(139, 92, 246, 0.03)',
    bgProgress: 'rgba(139, 92, 246, 0.15)',

    // Borders
    border: 'rgba(139, 92, 246, 0.1)',
    borderMedium: 'rgba(139, 92, 246, 0.2)',

    // Shadows
    shadow: 'rgba(139, 92, 246, 0.3)',
    shadowStrong: 'rgba(139, 92, 246, 0.4)',
    shadowLight: 'rgba(139, 92, 246, 0.5)',

    // Box shadows (complete values)
    boxShadowButton: '0 8px 24px rgba(139, 92, 246, 0.4), 0 4px 12px rgba(124, 58, 237, 0.3)',
    boxShadowButtonHover: '0 12px 32px rgba(139, 92, 246, 0.5), 0 6px 16px rgba(124, 58, 237, 0.4)',
    boxShadowDrawer: '0 20px 60px rgba(139, 92, 246, 0.3), 0 8px 24px rgba(0, 0, 0, 0.12)',
};

export default AI_COLORS;
